<template>
  <v-dialog persistent v-model="activeModal" max-width="800">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="headline">{{ title }}</span>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text>
        <GrupoForm
          @save="handleSave"
          @cancel="close"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GrupoForm from "../../../components/forms/GrupoForm.vue";

export default {
  name: "CriarGrupoModal",
  components: {
    GrupoForm
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Criar Grupo"
    }
  },
  methods: {
    async handleSave(formData) {
      try {
        // Emite evento para o componente pai com os dados do formulário
        this.$emit('grupo-criado', formData);
        
        // Fecha o modal
        this.close();
      } catch (error) {
        console.error('Erro ao criar grupo:', error);
        throw error;
      }
    },

    close() {
      this.$emit('update:activeModal', false);
    }
  }
};
</script>

<style scoped>
.v-dialog {
  border-radius: 12px;
}

.v-card {
  border-radius: 12px;
}

.v-card-title {
  background-color: #F8FAFC;
  border-bottom: 1px solid #E5E7EB;
  padding: 20px 24px;
}

.headline {
  color: #1F2937;
  font-size: 1.5rem;
  font-weight: 700;
}
</style>